import React from 'react';
import { AlertTriangle, Info, XCircle } from 'lucide-react';
import type { BrandTeamStatus } from '../../../../services/brandTeamService';

interface StatusBannersProps {
  schemaStatus: BrandTeamStatus | null;
  error: string | null;
}

const StatusBanners: React.FC<StatusBannersProps> = ({ schemaStatus, error }) => {
  return (
    <>
      {error && (
        <div className="flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3">
          <XCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-500" />
          <div className="text-sm text-red-700">{error}</div>
        </div>
      )}
      {schemaStatus && !schemaStatus.ready && (
        <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 text-amber-600" />
            <h3 className="font-heading font-semibold text-amber-900 text-sm">Brand Team Setup Required</h3>
          </div>
          <p className="mt-1 text-xs text-amber-800">{schemaStatus.message}</p>
          {schemaStatus.missing.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-1.5">
              {schemaStatus.missing.map((item) => (
                <span key={item} className="rounded-md bg-white/80 px-2 py-0.5 font-mono text-[10px] text-amber-900">{item}</span>
              ))}
            </div>
          )}
        </div>
      )}
      {schemaStatus?.ready && !schemaStatus.anthropicConfigured && (
        <div className="rounded-xl border border-blue-200 bg-blue-50 p-4">
          <div className="flex items-center gap-2">
            <Info className="h-4 w-4 text-blue-600" />
            <h3 className="font-heading font-semibold text-blue-900 text-sm">Agent Runtime Not Configured</h3>
          </div>
          <p className="mt-1 text-xs text-blue-800">
            Running in heuristic fallback mode. Add <code className="rounded bg-blue-100 px-1 py-0.5 text-[10px]">ANTHROPIC_API_KEY</code> to enable the full multi-agent runtime.
          </p>
        </div>
      )}
    </>
  );
};

export default StatusBanners;
